import { IProductPricesApi } from "api/interfaces/category-api.type";
import axios from "fetch-api/fetch-api";

export function getProductPricesApi(skus: string[]) {
  return axios.post<IProductPricesApi>("/get-product-prices", {
    skus,
  });
}
